var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import styled from 'styled-components';
import { Box } from '@ally/metronome-ui';
import { formattedDate, isAfterDeliverOnDate } from '../utils';
import { trackerSteps, trackerStatuses } from '../../constants';
import TimelineTrackerStep from './TimelineTrackerStep';
import SummaryTrackerStep from './SummaryTrackerStep';
var TimelineTrackerSteps = styled.ol(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  text-align: center;\n  align-items: start;\n  margin: 0 auto;\n  padding: 0;\n  list-style: none;\n  counter-reset: counter;\n\n  ", "\n\n  && li:nth-child(odd) {\n    background: transparent;\n  }\n"], ["\n  display: flex;\n  text-align: center;\n  align-items: start;\n  margin: 0 auto;\n  padding: 0;\n  list-style: none;\n  counter-reset: counter;\n\n  ", "\n\n  && li:nth-child(odd) {\n    background: transparent;\n  }\n"])), function (_a) {
    var isSummaryView = _a.isSummaryView, media = _a.theme.media;
    return "\n    ".concat(isSummaryView
        ? "\n          justify-content: space-between;\n          align-content: stretch;\n        "
        : "\n          ".concat(media.down('md'), " {\n            display: block;\n            text-align: left;\n          }\n        "), "\n  ");
});
function getCanceledSteps(_a) {
    var activityName = _a.activityName, statuses = _a.statuses;
    if (statuses.length === 1) {
        return ['Requested', 'Canceled'];
    }
    var allsteps = trackerSteps[activityName];
    var canceledAfterRequested = statuses.length === 2;
    var statusBeforeCanceled = statuses[1] && statuses[1].status;
    var stepBeforeIndex = allsteps.indexOf(statusBeforeCanceled);
    var canceledSteps = canceledAfterRequested
        ? allsteps.slice(0, 1)
        : allsteps.slice(0, stepBeforeIndex);
    return __spreadArray(__spreadArray([], __read(canceledSteps), false), ['Canceled'], false);
}
function getStepStatus(_a) {
    var activityName = _a.activityName, currentStatus = _a.currentStatus, step = _a.step;
    var steps = trackerSteps[activityName];
    var warningStatus = currentStatus === 'VerificationRequired';
    if (warningStatus && step === 'Reviewing')
        return 'Warning';
    var canceledStatus = currentStatus === 'Canceled';
    if (currentStatus === step && canceledStatus)
        return 'Canceled';
    var successStatus = trackerStatuses.success.includes(currentStatus);
    var firstStepSuccess = activityName === 'InternalTransfers'
        ? 'Processing'
        : trackerSteps.firstSuccess.includes(step);
    var currentStep = step === currentStatus;
    // make requested/processing step always checked and then assign checkmarks/numbers/needs attention to all other steps based on status
    var currentStatusIndex = steps.map(function (event) { return event; }).indexOf(currentStatus);
    var statusIndex = currentStatus === 'VerificationRequired'
        ? currentStatusIndex - 1
        : currentStatusIndex;
    var prevSteps = steps.slice(0, statusIndex);
    var prevStepIndex = prevSteps.indexOf(step);
    var successStatuses = firstStepSuccess ||
        prevSteps[prevStepIndex] ||
        (currentStep && successStatus);
    if (successStatuses)
        return 'Success';
    if (currentStep)
        return 'Current';
    return '';
}
function getAriaLabel(_a) {
    var event = _a.event, steps = _a.steps;
    var activityName = event.activityName, eventModelData = event.eventModelData, statuses = event.statuses;
    var currentStatus = statuses[0].status;
    function getAriaStepStatus(step) {
        var deliverOnDate = eventModelData.deliverOnDate;
        var allSteps = trackerSteps[activityName];
        var currentStatusIndex = allSteps
            .map(function (stepItem) { return stepItem; })
            .indexOf(currentStatus);
        var statusIndex = currentStatus === 'VerificationRequired'
            ? currentStatusIndex - 1
            : currentStatusIndex;
        var prevSteps = allSteps.slice(0, statusIndex);
        var skippedStep = prevSteps.includes(step);
        var isAch = activityName === 'ACHTransfer';
        var afterDeliverOnDate = isAfterDeliverOnDate(deliverOnDate);
        var formattedDeliverOnDate = formattedDate(deliverOnDate, 'MMM D');
        var stepContent = function () {
            if (isAch) {
                if (step === 'Completed') {
                    return afterDeliverOnDate ? 'Delivered' : 'Deliver On';
                }
                return 'Processing';
            }
            if (step === 'Posted')
                return 'Delivered';
            return step;
        };
        var historyDate = statuses.find(function (history) {
            if (step === 'Ordered') {
                return trackerStatuses.ordered.includes(history.status);
            }
            return history.status === step;
        });
        if (historyDate || deliverOnDate) {
            var historyStatus = historyDate === null || historyDate === void 0 ? void 0 : historyDate.status;
            var historyStatusDate = formattedDate(historyDate === null || historyDate === void 0 ? void 0 : historyDate.eventDateTime, 'MMM D');
            var isInProgress = (currentStatus === 'Reviewing' && historyStatus === 'Reviewing') ||
                (currentStatus === 'Processing' && historyStatus === 'Processing');
            var isOnHold = currentStatus === 'VerificationRequired' &&
                historyStatus === 'Reviewing';
            if (isInProgress) {
                return "".concat(stepContent(), " in progress on ").concat(historyStatusDate);
            }
            if (isOnHold) {
                return "".concat(stepContent(), " on hold ").concat(historyStatusDate);
            }
            if (isAch && !afterDeliverOnDate) {
                return "".concat(stepContent(), " ").concat(formattedDeliverOnDate);
            }
            return "".concat(stepContent(), " complete on ").concat(isAch ? formattedDeliverOnDate : historyStatusDate);
        }
        if (skippedStep && !historyDate) {
            return "".concat(stepContent(), " complete");
        }
        return "".concat(stepContent());
    }
    return "\n    ".concat(steps.length, " step process:\n    ").concat(steps
        .map(function (step, i) { return "step ".concat(i + 1, ", ").concat(getAriaStepStatus(step)); })
        .join(', '), "\n  ");
}
var TimelineTracker = function (_a) {
    var event = _a.event, _b = _a.isSummaryView, isSummaryView = _b === void 0 ? false : _b;
    var activityName = event.activityName, statuses = event.statuses;
    var currentStatus = statuses[0].status;
    var steps = currentStatus === 'Canceled'
        ? getCanceledSteps({ activityName: activityName, statuses: statuses })
        : trackerSteps[activityName];
    var ariaLabel = getAriaLabel({ event: event, steps: steps });
    return (React.createElement(Box, { "aria-label": ariaLabel, role: "img" },
        React.createElement(TimelineTrackerSteps, { "aria-hidden": "true", isSummaryView: isSummaryView }, steps.map(function (step) {
            var stepStatus = getStepStatus({
                activityName: activityName,
                step: step,
                currentStatus: currentStatus,
            });
            var historyCollection = statuses.find(function (history) {
                if (step === 'Ordered') {
                    return trackerStatuses.ordered.includes(history.status);
                }
                return history.status === step;
            });
            return isSummaryView ? (React.createElement(SummaryTrackerStep, { event: event, isCanceled: currentStatus === 'Canceled', status: stepStatus, step: step })) : (React.createElement(TimelineTrackerStep, { event: event, status: stepStatus, statusHistory: historyCollection, step: step }));
        }))));
};
export default TimelineTracker;
var templateObject_1;
//# sourceMappingURL=index.js.map